export const initialQuizState = {
  id: null,
  name: null,
  organization_id: null,
  auth_steps: [],
  game_mode: [],
  administered: null,
  accessible_from: null,
  accessible_until: null,
  config: {},
};

export const quizReducer = (state = initialQuizState, action) => {
  switch (action.type) {
    case "SET_QUIZ":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
